import React from "react";
import { Card } from "react-bootstrap";
import catalogStyles from "../css/Catalogue.module.css";

const moneyFormater = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "PGK"
});

export const SelectedServiceItemDetails = ({item, deptLogo}) => {

  return (
    <Card>
      <div className="d-flex justify-content-center" style={{borderRadius: '5px', backgroundImage: 'url(../media/bg/bg-1.jpg)', backgroundSize: '100% 100%'}}>
        <Card.Img
          variant="top"
          src={deptLogo}
          style={{ width: '45%', height: '70%', marginTop: '15px'}}
        />
      </div>
      <Card.Body>
        <Card.Title>
          <h4>Selected Service Details</h4>
        </Card.Title>
        <table className={`card-table table-borderless ${catalogStyles.selectedServiceTable}`}>
          <tbody>
            <tr>
              <td><strong>Province:</strong></td>
              <td style={{paddingLeft:"10px"}}>{item.prov_name}</td>
            </tr>

            <tr><td colSpan="2">&nbsp;</td></tr>

            <tr>
              <td><strong>Department:</strong></td>
              <td style={{paddingLeft:"10px"}}>{item.dept_name}</td>
            </tr>
            
            <tr><td colSpan="2">&nbsp;</td></tr>

            <tr>
              <td><strong>Service:</strong></td>
              <td style={{paddingLeft:"10px"}}>{item.serv_name}</td>
            </tr>        
            
            <tr><td colSpan="2">&nbsp;</td></tr>
    
            <tr>
              <td><strong>Revenue Code:</strong></td>
              <td style={{paddingLeft:"10px"}}>{item.service_item_number}</td>
            </tr>

            <tr><td colSpan="2">&nbsp;</td></tr>

            <tr>
              <td><strong>Service Item:</strong></td>
              <td style={{paddingLeft:"10px"}}>{item.description}</td>
            </tr>

            <tr><td colSpan="2">&nbsp;</td></tr>

            <tr>
              <td><strong>Price:</strong></td>
              <td style={{paddingLeft:"10px"}}>{moneyFormater.format(item.price)}</td>
            </tr>
          </tbody>
        </table>
        
      </Card.Body>
    </Card>
  );
};
